export function builderSelectOptions(
  currentValue: string,
  configuredOptions: readonly string[],
): string[] {
  if (configuredOptions.includes(currentValue)) {
    return [...configuredOptions];
  }

  return [currentValue, ...configuredOptions];
}
